<template>
<div class="chapter">
<div class="inner_page">
<h2 id="sigil_toc_id_4">Contents</h2>
<p class="firstcenter"><a href="#/Text/preface#sigil_toc_id_5">Preface</a></p>
<p class="firstcenter"><a href="#/Text/intro#sigil_toc_id_6">Introduction</a></p>
<p class="firstcenter"><a href="#/Text/ch1#sigil_toc_id_7">1 What Is Church Planting?</a></p>
<p class="firstcenter"><a href="#/Text/ch2#sigil_toc_id_10">2 How’s Your Ecclesiology?</a></p>
<p class="firstcenter"><span href="#/Text/ch3#sigil_toc_id_14" title="Link target outside of Sample">3 Practices of Team Members</span></p>
<p class="firstcenter"><span href="#/Text/ch4#sigil_toc_id_16" title="Link target outside of Sample">4 Pathway to Planting</span></p>
<p class="firstcenter"><span href="#/Text/ch5#sigil_toc_id_21" title="Link target outside of Sample">5 Stages of Planting</span></p>
<p class="firstcenter"><span href="#/Text/ch6#sigil_toc_id_24" title="Link target outside of Sample">6 Planned Role Changes</span></p>
<p class="firstcenter"><span href="#/Text/ch7#sigil_toc_id_32" title="Link target outside of Sample">7 Church Multiplication Cycle</span></p>
<p class="firstcenter"><span href="#/Text/ch8#sigil_toc_id_34" title="Link target outside of Sample">8 Methods</span></p>
<p class="firstcenter"><span href="#/Text/ch9#sigil_toc_id_37" title="Link target outside of Sample">9 Where to Begin?</span></p>
<p class="firstcenter"><span href="#/Text/ch10#sigil_toc_id_42" title="Link target outside of Sample">10 Pastoral Development</span></p>
<p class="firstcenter"><span href="#/Text/ch11#sigil_toc_id_47" title="Link target outside of Sample">11 Strategy Development</span></p>
<p class="firstcenter"><span href="#/Text/ch12#sigil_toc_id_52" title="Link target outside of Sample">12 Ethical Guidelines</span></p>
<p class="firstcenter"><span href="#/Text/conclusion#sigil_toc_id_56" title="Link target outside of Sample">Conclusion</span></p>
<p class="firstcenter"><span href="#/Text/acknowledgments#sigil_toc_id_57" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="firstcenter"><span href="#/Text/notes#sigil_toc_id_59" title="Link target outside of Sample">Notes</span></p>
<p class="firstcenter"><span href="#/Text/bibliography#sigil_toc_id_69" title="Link target outside of Sample">Bibliography</span></p>
<p class="firstcenter"><span href="#/Text/praise#sigil_toc_id_70" title="Link target outside of Sample">Praise for <i>Apostolic Church Planting</i></span></p>
<p class="firstcenter"><span href="#/Text/author" title="Link target outside of Sample">About the Author</span></p>
<p class="firstcenter"><span href="#/Text/moreIVP" title="Link target outside of Sample">More Titles from InterVarsity Press</span></p>
<p class="firstcenter"><span href="#/Text/copyright" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?90b0e968